"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

require("./AlertsContainer.scss");

var _RemindersContainer = _interopRequireDefault(require("../reminders/RemindersContainer"));

var types = _interopRequireWildcard(require("../../store/actions/actionTypes"));

var _PulseNotificationMessageWrapper = _interopRequireDefault(require("../message/PulseNotificationMessageWrapper"));

var _Card = _interopRequireDefault(require("../card/Card"));

var Constants = _interopRequireWildcard(require("../../constants/Constants"));

var _reactTransitionGroup = require("react-transition-group");

var _adobeIntlReact = _interopRequireWildcard(require("@adobe/adobe-intl-react"));

var localizationStrings = _interopRequireWildcard(require("./__localization__/AlertsContainer"));

var _metrics = _interopRequireDefault(require("@exc/runtime/metrics"));

/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2019 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 *************************************************************************/
var AlertsContainer =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(AlertsContainer, _Component);

  function AlertsContainer(props) {
    var _this;

    (0, _classCallCheck2.default)(this, AlertsContainer);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(AlertsContainer).call(this, props));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
      reminders: [],
      notifications: [],
      showContainer: false
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onAlertFetched", function () {
      var notifications = _this.props.store.getState().notifications.alerts;

      if (notifications.length > 0) {
        _this.scheduler = setTimeout(function () {
          _this.props.store.dispatch({
            type: types.MARK_NOTIFICATIONS_AS_SHOWN,
            ids: notifications
          });
        }, Constants.FLOATING_NOTIFICATION_TIMEOUT_IN_MILLISECONDS);
      }

      _this.setState({
        reminders: _this.props.store.getState().reminders.reminders,
        notifications: notifications,
        showContainer: _this.props.store.getState().reminders.reminders.length > 0
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "renderNotifications", function (locale) {
      var notifications = _this.state.notifications;
      return notifications.map(function (entry) {
        var notification = _this.props.store.getState().notifications.byId[entry];

        return _react.default.createElement(_reactTransitionGroup.CSSTransition, {
          key: entry,
          timeout: 5000,
          classNames: "pulse-alert"
        }, _react.default.createElement("div", {
          style: {
            marginBottom: '1rem'
          }
        }, _react.default.createElement(_Card.default, null, _react.default.createElement(_PulseNotificationMessageWrapper.default, {
          pulseMessageObject: notification,
          isFloatingAlert: true,
          locale: locale
        }))));
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onAllRemindersClosed", function () {
      _this.metrics.event("all.reminders.close", {
        region: window.config && window.config.region
      });

      _this.props.store.dispatch({
        type: types.MARK_ALL_REMINDERS_AS_SHOWN
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onReminderClosed",
    /*#__PURE__*/
    function () {
      var _ref = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee(id) {
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.metrics.event("reminder.close", {
                  region: window.config && window.config.region
                });

                _context.next = 3;
                return _this.props.store.dispatch({
                  type: types.MARK_REMINDER_AS_SHOWN,
                  ids: [id]
                });

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }());
    _this.metrics = _metrics.default.create("exc.pulse.components.alerts.AlertsContainer");
    return _this;
  }

  (0, _createClass2.default)(AlertsContainer, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.unsubscribe = this.props.store.subscribe(this.onAlertFetched);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$state = this.state,
          showContainer = _this$state.showContainer,
          reminders = _this$state.reminders;
      var locale = this.props.store.getState().notifications.locale;
      return _react.default.createElement("div", {
        className: "pulse-alerts-container"
      }, showContainer && reminders.length > 0 && _react.default.createElement(_reactTransitionGroup.CSSTransition, {
        timeout: 500,
        classNames: "alert"
      }, _react.default.createElement(_adobeIntlReact.default, {
        locale: locale,
        localeData: localizationStrings
      }, _react.default.createElement(_RemindersContainer.default, {
        reminders: this.state.reminders,
        onClose: this.onAllRemindersClosed,
        onReminderClosed: this.onReminderClosed,
        closeHandler: this.onAllRemindersClosed
      }))), _react.default.createElement(_reactTransitionGroup.TransitionGroup, null, this.renderNotifications(locale)));
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.unsubscribe();
    }
  }]);
  return AlertsContainer;
}(_react.Component);

exports.default = AlertsContainer;
(0, _defineProperty2.default)(AlertsContainer, "defaultProps", {
  locale: 'en-US',
  localizationStrings: {
    DismissReminder: "Dismiss Reminder",
    DismissAlert: "Dismiss",
    Snooze: "Snooze",
    DeleteReminder: "Delete Reminder",
    EditReminder: "Edit Reminder",
    RemindMeTomorrow: "Remind me tomorrow",
    RemindMe60Min: "Remind me in an hour",
    RemindMe15Min: "Remind me in 15 minutes",
    RemindMe5Min: "Remind me in 5 minutes",
    DismissAllReminders: "Dismiss All Reminders",
    Reminder: "Reminder",
    Reminders: "Reminders"
  }
});